import { render, staticRenderFns } from "./PublicClass.vue?vue&type=template&id=68b57668&scoped=true"
import script from "./PublicClass.vue?vue&type=script&lang=js"
export * from "./PublicClass.vue?vue&type=script&lang=js"
import style0 from "./PublicClass.vue?vue&type=style&index=0&id=68b57668&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b57668",
  null
  
)

export default component.exports